/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invitationDataStatusSchema = z.enum(['pending', 'accepted', 'revoked', 'expired'])

export type InvitationDataStatusSchema = z.infer<typeof invitationDataStatusSchema>
